/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneInput/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaSelectOneInput({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneInput",
  inputRef,
  autoComplete = "off",
  dataOpIgnore,
  autoFocus,
  type = "text",
  tabIndex,
  placeholder,
  onChangeFilter,
  onBlur,
  onFocus,
  onKeyUp,
  valueFilter,
  disabled,
  selectedPlaceholder,
  optionValue,
  size,
  weight
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="TysiaSelectOneInput.Capture"
  data-view-path={viewPath}
 ref={inputRef}
 autoComplete={autoComplete}
 data-op-ignore={dataOpIgnore}
 autoFocus={autoFocus}
 tabIndex={tabIndex}
 placeholder={selectedPlaceholder ? selectedPlaceholder : placeholder}
 onChange={(e) => onChangeFilter && onChangeFilter(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={optionValue ? optionValue : valueFilter}
 disabled={disabled}
 style={{'--c-1-Z1MSS4l': dtColorsNeutral900,'--c-5-Z1MSS4l': disabled ? "not-allowed" : "pointer",'--fs-3-Z1MSS4l': size == "small" ? "12px" : "13px",'--lh-4-Z1MSS4l': size == "small" ? "16px" : "20px",'--fw-2-Z1MSS4l': weight == "medium" ? 500 : 400}}
 className={`views-capture ${styles.Capture}`}
/>
{children}
</React.Fragment>)
}